<template>
  <wrap-container>
    <help-title title="Pin Banelco Bloqueado" />

    <help-list-container>
      <help-list-item tituloLista="Banca Online:">
        Ingresá con tu Usuario y Clave Digital a Tarjetas ➜ Visa Débito ➜ Voy a
        ➜ Blanquear PIN y Clave Línea BBVA 0800-333-0303 - Sistema automático.
        Opciones: 4 (tarjetas) ➜ 2 (tarjetas visa débito) ➜ 4 (Blanqueo de PIN
        Banelco). <br />Deberás contar con tu Clave BBVA (4 dígitos)
      </help-list-item>
      <help-list-item tituloLista="Más información:">
        Encontrá más información sobre inversiones en nuestro sitio
        <custom-link
          label="Ver más Información"
          href="https://www.bbva.com.ar/personas/productos/inversiones.html"
        />
      </help-list-item>
      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad.
        <contact-link />
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import CustomLink from "@/components/core/CustomLink";
import ContactLink from "@/components/core/ContactLink";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    CustomLink,
    ContactLink
  }
};
</script>
